// YouTube Reels/Shorts Data
export const youtubeReelsData = {
  en: [
    {
      id: 1,
      title: "Param Pujya Gurumauli Amrittulya Hitguj",
      thumbnailUrl: "https://img.youtube.com/vi/Z9H7T7gPY5M/maxresdefault.jpg",
      videoId: "Z9H7T7gPY5M",
      description: ""
    },
    {
      id: 2,
      title: "Global Agriculture Festival 2026",
      thumbnailUrl: "https://img.youtube.com/vi/dohcsIlAbrk/maxresdefault.jpg",
      videoId: "dohcsIlAbrk",
      description: "Krushi Mahotsav"
    },
    {
      id: 3,
      title: "Shree Ghor Kashtodwarak Seva",
      thumbnailUrl: "https://img.youtube.com/vi/EH8bHnCeXnM/maxresdefault.jpg", // ✅ FIXED
      videoId: "EH8bHnCeXnM",
      description: "Shree Ghor Kashtodwarak Seva"
    },
    {
      id: 4,
      title: "Skill Development",
      thumbnailUrl: "https://img.youtube.com/vi/6JSiEUtimkk/maxresdefault.jpg",
      videoId: "6JSiEUtimkk",
      description: "Youth empowerment"
    }
  ],
  mr: [
    {
      id: 1,
      title: "परमपूज्य गुरुमाऊली अमृततूल्य हितगूज",
      thumbnailUrl: "https://img.youtube.com/vi/Z9H7T7gPY5M/maxresdefault.jpg",
      videoId: "Z9H7T7gPY5M",
      description: ""
    },
    {
      id: 2,
      title: "जागतिक कृषी महोत्सव 2026",
      thumbnailUrl: "https://img.youtube.com/vi/dohcsIlAbrk/maxresdefault.jpg",
      videoId: "dohcsIlAbrk",
      description: "सेंद्रिय व नैसर्गिक शेतीचा उत्सव"
    },
    {
      id: 3,
      title: "श्री घोर कष्टोद्वारक सेवा",
      thumbnailUrl: "https://img.youtube.com/vi/EH8bHnCeXnM/maxresdefault.jpg", // ✅ UPDATED
      videoId: "EH8bHnCeXnM", // ✅ UPDATED (was B3Mzm60qYYI)
      description: "श्री घोर कष्टोद्वारक सेवा"
    },
    {
      id: 4,
      title: "कौशल्य विकास",
      thumbnailUrl: "https://img.youtube.com/vi/6JSiEUtimkk/maxresdefault.jpg",
      videoId: "6JSiEUtimkk",
      description: "युवा सक्षमीकरण"
    }
  ]
};